const state = {
  jcourse: '', chooseMenuId: '', mineFlag: true, courseStatus: true, bindPhonePopFlag: false, videoTime: 0
};

const mutations = {
  saveJcourseInfo: (state, value) => {
    state.jcourse = ''
    state.jcourse = value
  }, saveChooseMenuId: (state, value) => {
    state.chooseMenuId = ''
    state.chooseMenuId = value
  }, saveMineFlag: (state, value) => {
    state.mineFlag = true;
    state.mineFlag = value;
  }, saveCourseStatus: (state, value) => {
    state.courseStatus = '';
    state.courseStatus = !value;
  }, saveBindPhoneStatus: (state, value) => {
    state.bindPhonePopFlag = value
  }, saveVideoTime: (state, value) => {
    console.log(value)
    state.videoTime = value;
  }
};

export default {
  state, mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/jCourse.js